module.exports = {
	"id": "IL",
	"name": "Israel",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.012148,
			"5": 0.012148,
			"6": null,
			"7": 0.024296,
			"8": 0.006074,
			"9": null,
			"10": 0.012148,
			"11": 0.054666,
			"12": 0.012148,
			"13": 0.006074,
			"14": 0.018222,
			"15": 0.018222,
			"16": 0.018222,
			"17": 0.024296,
			"18": 0.018222,
			"19": 0.012148,
			"20": 0.012148,
			"21": 0.03037,
			"22": 0.042518,
			"23": 0.024296,
			"24": 0.03037,
			"25": 0.018222,
			"26": 0.03037,
			"27": 0.012148,
			"28": 0.012148,
			"29": 0.012148,
			"30": 0.006074,
			"31": 0.09111,
			"32": 0.012148,
			"33": 0.012148,
			"34": 0.036444,
			"35": 0.036444,
			"36": 0.018222,
			"37": 0.03037,
			"38": 0.048592,
			"39": 0.127554,
			"40": 0.048592,
			"41": 0.03037,
			"42": 0.024296,
			"43": 0.18222,
			"44": 0.048592,
			"45": 0.036444,
			"46": 0.054666,
			"47": 0.066814,
			"48": 0.085036,
			"49": 2.107678,
			"50": 0.133628,
			"51": 0.72888,
			"52": 0.558808,
			"53": 29.537862,
			"54": 8.072346,
			"55": 0.109332,
			"56": 0.03037,
			"57": null
		},
		"firefox": {
			"2": 0.006074,
			"3": 0.048592,
			"4": 0.018222,
			"5": null,
			"6": null,
			"7": 0.012148,
			"8": null,
			"9": 0.042518,
			"10": 0.012148,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.012148,
			"17": null,
			"18": 0.006074,
			"19": null,
			"20": null,
			"21": 0.006074,
			"22": null,
			"23": null,
			"24": 0.006074,
			"25": 0.018222,
			"26": 0.03037,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.012148,
			"32": null,
			"33": 0.006074,
			"34": 0.042518,
			"35": 0.012148,
			"36": 0.012148,
			"37": 0.012148,
			"38": 0.024296,
			"39": 0.018222,
			"40": 0.012148,
			"41": 0.012148,
			"42": 0.036444,
			"43": 0.066814,
			"44": 0.024296,
			"45": 0.085036,
			"46": 0.072888,
			"47": 0.36444,
			"48": 0.291552,
			"49": 3.328552,
			"50": 0.036444,
			"51": null,
			"52": null,
			"3.5": 0.042518,
			"3.6": 0.18222
		},
		"opera": {
			"9": null,
			"11": 0.018222,
			"12": 0.06074,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.006074,
			"22": null,
			"23": 0.006074,
			"24": null,
			"25": null,
			"26": 0.012148,
			"27": 0.042518,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.042518,
			"35": null,
			"36": 0.012148,
			"37": 0.012148,
			"38": 0.085036,
			"39": 0.018222,
			"40": 0.218664,
			"41": 0.042518,
			"42": null,
			"43": null,
			"9.5-9.6": 0.006074,
			"10.0-10.1": 0.012148,
			"10.5": 0.012148,
			"10.6": 0.012148,
			"11.1": 0.012148,
			"11.5": 0.006074,
			"11.6": 0.072888,
			"12.1": 0.115406
		},
		"safari": {
			"0": null,
			"4": 0.024296,
			"5": 0.06074,
			"6": 0.012148,
			"7": 0.018222,
			"8": 0.078962,
			"9": 0.085036,
			"10": 0.63777,
			"3.1": null,
			"3.2": null,
			"5.1": 0.072888,
			"6.1": 0.03037,
			"7.1": 0.012148,
			"9.1": 0.406958
		},
		"ios_saf": {
			"8": 0,
			"10": 6.67899974688,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.179991314738,
			"8.1-8.4": 0.332526327227,
			"9.0-9.2": 0.158636412989,
			"9.3": 2.42022219817
		},
		"android": {
			"3": 0,
			"4": 0.026920751938,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00336509399225,
			"4.1": 0.097106998062,
			"4.2-4.3": 0.242767495155,
			"4.4": 0.55668269186,
			"4.4.3-4.4.4": 0.561489968992
		},
		"ie": {
			"6": 0.0122447004975,
			"7": 0.00612235024876,
			"8": 0.428564517413,
			"9": 0.251016360199,
			"10": 0.281628111443,
			"11": 5.1733859602,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0102910196977,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000285861658268
		},
		"edge": {
			"12": 0.066814,
			"13": 0.461624,
			"14": 1.554944
		},
		"ie_mob": {
			"10": 0.0154867605634,
			"11": 0.0630532394366
		},
		"bb": {
			"7": 0.003927,
			"10": null
		},
		"samsung": {
			"0": 3.824898
		},
		"and_uc": {
			"0": 0.113883
		},
		"op_mini": {
			"0": 0.138649118644
		},
		"and_chr": {
			"0": 25.410845
		},
		"and_ff": {
			"0": 0.015708
		}
	},
	"total": 99.02036
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IL.json
 ** module id = 549
 ** module chunks = 0
 **/